import { render, staticRenderFns } from "./SubscriptionTab.vue?vue&type=template&id=dca2815a"
import script from "./SubscriptionTab.vue?vue&type=script&lang=js"
export * from "./SubscriptionTab.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTab.vue?vue&type=style&index=0&id=dca2815a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports